import Vue from "vue";
import VueRouter from "vue-router";
import Register from "../views/Register.vue";
import Login from "../views/Login.vue";
import Registrado from "../components/Thanks";
import error from "../components/Error";
import Admin from "../components/Admin";
Vue.use(VueRouter);

const routes = [
  {
    path: "/registro",
    name: "register",
    component: Register,
  },
  {
    path: "/",
    name: "login",
    component: Login,
  },
  {
    path: "/error",
    name: "/error",
    component: error,
  },
  {
    path: "/registrado",
    name: "registered",
    component: Registrado,
  },
  {
    path: "/administrador",
    name: "administrador",
    component: Admin,
  },
  {
    path: "*", // Captura todas las rutas no definidas
    redirect: "/", // Redirige a la página de inicio de sesión
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
